import React, { useContext, useEffect, useState, useRef } from 'react'
import { Button, Col, Row, Spinner } from 'reactstrap'
import Breadcrumbs from '../../../global/Components/Breadcrumb/Breadcrumb'
import { getRequest } from '../../../global/utils/apiCall';
import AdvertiseCard from '../../../global/Components/Advertise/AdvertiseCard';
import useApiPrivate from '../../../global/utils/hooks/useApiPrivate';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './AdvertiseList.module.scss';
import { UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import { Toast } from 'primereact/toast';

const  ADVERTISE_URL = 'api/v1/advertise';

export default function AdvertiseList() {
    const apiPrivate = useApiPrivate();
    const [searchParams, setSearchParams] = useSearchParams();
    const {lang} = useContext(UserContext);
    const navigate = useNavigate();
    const toast = useRef(null);


    const [isLoading, setIsLoading] = useState(false);
    const [advertise, setAdvertise] =useState([]);
    const [selected, setSelected] = useState(null);
    const [productId, setproductId] = useState(searchParams.get('pId') || '');
    const [metaData, setMetaData] = useState();
    const [currentPage, setCurrentPage] = useState(searchParams.get('page') || 1);

    
    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const handleSelected = (adId) => {
        setSelected(adId);
    }

    const callAdvertise = async () => {
        setIsLoading(true);

        try {
            const response = await getRequest(ADVERTISE_URL,{
                params: {
                    page:'',
                    limit:''
                }
            });
            setAdvertise(response.data.data);
            setMetaData(response.data.meta);
            setCurrentPage(response.data.meta?.current_page);
            setIsLoading(false);
        }
        catch (error) {

            setIsLoading(false);
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleBuyAdvertise = async () => {
        setIsLoading(true);

        try {
            await apiPrivate.post(ADVERTISE_URL,{
                
                product_id: productId && productId,
                advertise_id: selected && selected,                
            });
            showSuccess('Success');
            setTimeout(() => {
                navigate('/dashboard/my-products');
              }, 2000);
        }
        catch (error) {
            setIsLoading(false);
            showError(error?.response?.data?.message);
        }
        finally {
            setIsLoading(false);
        }
    }

  

    useEffect(() => {
        callAdvertise();
    },[]);

    useEffect(() => {
        callAdvertise();
        currentPage &&
            searchParams.set('page', currentPage);
            setSearchParams(searchParams);
    },[currentPage]);

  return (
    <>
        <Toast ref={toast} position="top-center" />

        <div className={`bg-white p-4 mb-3 lgtBackground`}>
            <Row>
                <Col sm={8} md={8}>
                    <Breadcrumbs />
                </Col>
                <Col sm={4} md={4}>
                    <div className={`text-end ${styles.fsSmall}`}>
                        {
                        metaData ? (
                        <>
                            {metaData.total}
                            <span>
                                {' '}{showMsg('results', lang)}
                            </span>
                        </>
                        ) : (
                        <span>
                            {showMsg('no_results', lang)}
                        </span>
                        )
                        }
                </div>
                </Col>
            </Row>
            <Row>
                {/* <Col sm={12}>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore animi alias repellendus nostrum nobis voluptatum quidem ratione, beatae aspernatur earum! Voluptates nihil odio error id dicta sit mollitia ea a!
                    </p>
                </Col> */}
                <Row>
                    {
                        isLoading
                            ? <>
                                <Spinner color='primary' className='mx-auto text-center'>
                                    Loading...
                                </Spinner>
                            </>
                            : (
                                advertise.length > 0 
                                    ? (
                                        <>
                                        <p>
                                            Choose one of the following packages to be seen and grow your business:
                                        </p>
                                        {
                                            advertise.map((item) => (
                                                <Col sm={12} md={12} key={item.id}>
                                                    <AdvertiseCard advertise={item} onSelected={handleSelected} check={selected} />
                                                </Col>
                                            ))
                                        }
                                        <div>
                                            <Button 
                                                onClick={handleBuyAdvertise} 
                                                className={`${styles.buyBtn} px-4 fw-semibold`}
                                            >
                                                {
                                                    isLoading 
                                                    ? (
                                                        <>
                                                            <Spinner size="sm">
                                                                Loading...
                                                            </Spinner>
                                                            <span>
                                                                {' '}Loading
                                                            </span>
                                                        </>
                                                    )
                                                    : 'Buy'
                                                }
                                            </Button>
                                        </div>
                                        </>
                                    )
                                    : <p className="fw-bold py-4">
                                        No Adveties to Display
                                    </p>
                            )
                    }
                </Row>
            </Row>
        </div>
    </>
    )
}
